var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEllipsecheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24517 0.0391878C11.5109 -0.159137 13.7784 0.399256 15.6834 1.62465L14.5752 3.29972C13.0511 2.31941 11.2371 1.87269 9.42454 2.03135C7.612 2.19001 5.90616 2.94483 4.5811 4.17454C3.25605 5.40425 2.3887 7.03745 2.11842 8.81174C1.84814 10.586 2.19061 12.3984 3.09082 13.9577C3.99103 15.5169 5.3967 16.7326 7.082 17.4092C8.7673 18.0859 10.6344 18.1843 12.3832 17.6887C14.1321 17.1931 15.6613 16.1322 16.725 14.6765C17.7887 13.2208 18.3252 11.4548 18.2484 9.66219L20.275 9.57773C20.371 11.8185 19.7004 14.026 18.3707 15.8457C17.0411 17.6653 15.1296 18.9914 12.9436 19.6109C10.7575 20.2304 8.42362 20.1074 6.31699 19.2615C4.21037 18.4157 2.45328 16.8962 1.32802 14.9471C0.202759 12.998 -0.225335 10.7325 0.112516 8.51468C0.450368 6.29681 1.53455 4.25531 3.19087 2.71818C4.84719 1.18104 6.97949 0.237512 9.24517 0.0391878ZM10.8441 13.2121L22.2539 1.96209L20.8497 0.537939L10.142 11.0957L5.77313 6.78793L4.36892 8.21208L9.43992 13.2121L10.142 13.9044L10.8441 13.2121Z",
    fill: "#2D63F9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsecheck);
export default __webpack_public_path__ + "static/media/ellipsecheck.d3c87fabf03f95b4e2304a9fc23d912e.svg";
export { ForwardRef as ReactComponent };